// style.ts
import styled from 'styled-components';
import { themeOptions } from 'styles/theme';

interface StyledBasicSelectProps {
  $marginbottom?: string;
  $isusepadding?: string;
  $width?: string;
}

export const StyledBasicSelect = styled.div<StyledBasicSelectProps>`
  margin-bottom: ${(props) => (props.$marginbottom ? props.$marginbottom : '20px')};
  text-align: left;

  span {
    font-weight: 600;
    display: inline-block;
    margin-bottom: 7px;

    &.placeholder {
      font-weight: 400;
      color: #adadad;
    }
  }

  .bs-label {
    display: flex;
    align-items: center;
    position: relative;

    span {
      width: 10px;
      height: 5px;
      position: relative;
      top: -4px;
      left: 2px;
    }
  }

  && {
    .MuiInputBase-root {
      padding-right: 8px;
      padding-left: ${(props) => (props.$isusepadding === 'true' ? '12px' : '0')};
      height: 40px;
      width: ${(props) => (props.$width ? props.$width : null)};
      border-radius: 6px;
      border: 1px solid ${themeOptions.palette.gray.border};
      background-color: ${themeOptions.palette.white.main};

      &:hover {
        box-shadow: 0 0 0 3px var(--color-off-white);
        .MuiOutlinedInput-notchedOutline {
          border: 1px solid #dadada;
        }
      }
    }
    .MuiSelect-select {
      padding: 0 0 0 1px;
      width: ${(props) => (props.$width ? props.$width : null)};
      border-radius: 6px;
      box-sizing: border-box;
      background-color: ${themeOptions.palette.white.main};

      p {
        display: flex;
        align-items: center;
        color: ${themeOptions.palette.gray.dark};
      }
    }
    .MuiOutlinedInput-notchedOutline {
      border: 1px solid #dadada;
      padding-right: 8px;
    }
    .Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-width: 1px;
      }
    }

    .MuiPaper-root {
      box-shadow: 0px 4px 10px 0px #0000001a;
      border: 1px solid #dadada;
      border-radius: 6px;
      .MuiList-root {
        padding: 5px;
        .MuiButtonBase-root {
          height: 40px;
          border-radius: 4px;
        }
        &.Mui-selected {
          background-color: ${themeOptions.palette.green.main} !important;
        }
      }
    }

    .required {
      margin-top: 4px;
      margin-right: 0;
    }

    .MuiOutlinedInput-root.Mui-disabled {
      background-color: ${themeOptions.palette.gray.light};
    }
  }
`;
